import React from 'react';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ContextualAnalyticsData, BANNER } from '@atlassian/jira-product-analytics-bridge';
import { useRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { virtualAgentKnowledgebaseTouchpointResource } from '@atlassian/jira-router-resources-service-desk-virtual-agent/src/knowledge-base-touchpoint/index.tsx';
import { useIsJCSProjectType } from '@atlassian/jira-servicedesk-customer-service-common/src/utils/use-is-jcs/index.tsx';
import { isFedRamp } from '@atlassian/atl-context';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { VirtualServiceAgentCtaCard } from './main.tsx';

export const VirtualServiceAgentTouchpoint = () => {
	const { data: project } = useProjectContext();
	const isJCS = useIsJCSProjectType(project?.projectType);

	const { queryReference } = useRelayResource(virtualAgentKnowledgebaseTouchpointResource);

	if (isJCS || isFedRamp() || queryReference == null) {
		return null;
	}

	return (
		<ContextualAnalyticsData
			sourceType={BANNER}
			sourceName="servicedeskVirtualAgentKnowledgeBaseTouchpoint"
		>
			<JSErrorBoundary
				id="virtualAgentKnowledgeBaseTouchpoint"
				packageName="servicedeskVirtualAgentKnowledgeBaseTouchpoint"
				fallback="unmount"
				teamName="jsd-flux-capacitors"
			>
				<Placeholder name="virtual-agent-knowledge-base-touchpoint" fallback={<></>}>
					<VirtualServiceAgentCtaCard queryReference={queryReference} />
				</Placeholder>
			</JSErrorBoundary>
		</ContextualAnalyticsData>
	);
};
